/**
 * React 18 hooks shim for use with React 17.
 * Re-exports React 17 and adds useId, useDeferredValue, useInsertionEffect
 * so packages that require React 18 (e.g. @ingestro/importer-react) can run.
 * Import 'react-original' here to avoid circular resolution (webpack aliases react -> this file).
 * Uses a Proxy so every property (including minified/internal e.g. 'S' for React Refresh) is forwarded.
 */
const React = require('react-original');

let idCounter = 0;

function useId() {
  const [id] = React.useState(() => `:r${++idCounter}:`);
  return id;
}

function useDeferredValue(value) {
  return value;
}

const useInsertionEffect = React.useLayoutEffect;

const overrides = {
  useId,
  useDeferredValue,
  useInsertionEffect
};

const handler = {
  get(target, prop) {
    return overrides.hasOwnProperty(prop) ? overrides[prop] : target[prop];
  },
  has(target, prop) {
    return overrides.hasOwnProperty(prop) || prop in target;
  },
  getOwnPropertyDescriptor(target, prop) {
    return overrides.hasOwnProperty(prop)
      ? {
          configurable: true,
          enumerable: true,
          value: overrides[prop],
          writable: true
        }
      : Object.getOwnPropertyDescriptor(target, prop);
  },
  ownKeys(target) {
    return [
      ...new Set([
        ...Object.getOwnPropertyNames(target),
        ...Object.getOwnPropertySymbols(target),
        ...Object.keys(overrides)
      ])
    ];
  }
};

const exports = new Proxy(React, handler);
exports.__esModule = true;
exports.default = exports;
module.exports = exports;
